import uploadAttendeesDialogTemplate from './UploadAttendeesDialog.html';

/*****************************************************************************
 * Service: UploadAttendeesDialog */
/**
 * @ngdoc     service
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.service:UploadAttendeesDialog
 * @description
 * Dialog
 *****************************************************************************/
/* @ngInject */ export function UploadAttendeesDialogService($q, $uibModal, BusyScreen, Events, Tools) {
  /*****************************************************************************
   * show */
  /**
   * @ngdoc    function
   * @name     show
   * @methodOf csm.books.eventsAdmin.UploadAttendeesDialog
   * @param    event  Event the attendees will belong to.
   * @return   {Promise}    Resolves upon close.
   * @description
   *
   *****************************************************************************/
  this.show = function (event) {
    return $uibModal.open({
      animation: false,
      backdrop: 'static',
      component: 'uploadAttendeesDialog',
      size: 'lg',
      resolve: {
        event: function () {
          return event;
        }
      }
    }).result;
  };
}

/*****************************************************************************
 * Component: uploadAttendeesDialog */
/**
 * @ngdoc     component
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.component:uploadAttendeesDialog
 * @param  {Object} modalInstance $uibModal instance from $uibModal.open method
 * @param  {Object} resolve       Resolve object passed from $uibModal.open method
 * @description
 * This...
 *****************************************************************************/
export const uploadAttendeesDialogComponent = {
  template: uploadAttendeesDialogTemplate,
  bindings: { modalInstance: '<', resolve: '<' },
  controller: Controller
}

/*****************************************************************************
 * Controller: Controller */
/**
 * @ngdoc     controller
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.controller:Controller
 * @methodof  csm.books.eventsAdmin.uploadAttendeesDialog
 * @description
 * Controller for the uploadAttendeesDialog component.
 *****************************************************************************/
/* @ngInject */ function Controller($injector) {
  var $ctrl = this;
  $ctrl.$onInit = $injector.invoke($onInit, null, { $ctrl: $ctrl });
}

/*****************************************************************************
 * $onInit */
/**
 * @ngdoc    function
 * @name     csm.books.eventsAdmin.controller:$onInit
 * @methodof  csm.books.eventsAdmin.uploadAttendeesDialog
 * @description
 * Called by angular when the component is ready. This will set up some
 * properties from the bound values.
 *****************************************************************************/
/* @ngInject */ function $onInit($ctrl, $location, Alert) {
  return function () {
    /** Event Object.    */ $ctrl.event = $ctrl.resolve.event;
    /** Upload page URI. */ var UPLOAD_URI =
      'books/apps/eventsAdmin/AttendeesUpload.aspx?eventID=';

    /*--------------------------------*/
    /* Get a reference to the iframe. */
    /*--------------------------------*/
    var iframe = angular.element(document.getElementById('iframeUpload'));

    /*-------------------------------------------*/
    /* Set the iframe src using the absolute     */
    /* url including the current session string. */
    /*-------------------------------------------*/
    var urlEnd = $location.absUrl().indexOf('))/') + 3;
    var baseUrl = $location.absUrl().substring(0, urlEnd);
    iframe.attr('src', baseUrl + UPLOAD_URI + $ctrl.event.id);

    /*--------------------------------------------------------------*/
    /* Attach a reference to a function on the window object that   */
    /* will be called by the upload page upon successful upload.    */
    /* Closes the window and removes itself from the window object. */
    /*--------------------------------------------------------------*/
    window.document.uploadComplete = function () {
      Alert.success('Upload successful');
      $ctrl.modalInstance.close();

      /*-------------------------------*/
      /* Cleanup global window object. */
      /*-------------------------------*/
      delete window.document.uploadComplete;
    };

    /*------------------------------------------------*/
    /* Create references to the modal dismiss method. */
    /*------------------------------------------------*/
    $ctrl.dismiss = $ctrl.modalInstance.dismiss;
  };
}
